// extracted by mini-css-extract-plugin
export default {"root":"awards-module--root--eebd6","container":"awards-module--container--083ac","slides":"awards-module--slides--6bee6","swiper":"awards-module--swiper--e9a00"};